import React from 'react';
import { SvgProps } from '../../../models/components/svg';

const PizzaHutIcon: React.FC<SvgProps> = ({ className }) => {
    return <img src="/assets/images/PizzaHut/PizzaHut-Icon.png" alt="Pizza Hut" className={className} />
};

export default PizzaHutIcon;
